<div class="row_1">
    <div>
        <label class="label tab-heading " *ngIf="isAccessible" (click)="openRouteLevel('tier-setup')">Tier
            Setup</label>
        <label class="label tab-heading  titlered" matTooltip="Errors/Warnings Configuration">E/W Configuration</label>
        <label class="label tab-heading " *ngIf="isAccessible" (click)="openRouteLevel('history')">History</label>
        <label class="label tab-heading" *ngIf="isAccessible" (click)="openRouteLevel('periods')">Periods</label>
        <button class="primarybutton" style="float: right;" *ngIf="false" (click)="AddToQueue();">Add To
            Queue</button>
    </div>
    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>
        <img src="./assets/images/refresh_button.svg" class="refresh-button" (click)="refreshData()">
        <app-periods-dropdown periodLabel="Period" (eventHandler)="componentEventHandler($event);">
        </app-periods-dropdown>


        <button class="primarybutton" style="float: right;margin-right: 1%;" (click)="copyDialog();">COPY</button>
        <button class="primarybutton" style="float: right;" (click)="addDialog();">ADD</button>
        <div class="grid-agg">
            <label class="gridcaption">E/W Configuration</label>
            <ag-grid-angular #agGrid style="width:100%;height: 390px;" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
                (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true"
                [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="displayRowData"
                  [context]="context" [pagination]="true" [paginationPageSize]="rowCount"
                [icons]="icons">
            </ag-grid-angular>
            <div class="row col-12" style="bottom: 24px;position: relative; padding-left :13px">

                <div class="w-25 col-4 ">
                    <div>
                        <label class="page-drpdwn-label">Records / Page: </label>&nbsp;
                        <select class="page-drpdwn" (change)="onPageSizeChanged($event)">
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="ALL" selected>ALL</option>
                        </select>
                        <!-- <label style="padding-left:9px"> of {{rowCount}}</label> -->
                    </div>
                </div>

                <div style="display: flex;" class="pagination_text col-4 offset-2">

                    <!-- first -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToFirstPage()"
                        [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                        first_page</mat-icon>

                    <!-- previous -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;" (click)="goToPreviousPage()"
                        [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                        keyboard_arrow_left</mat-icon>

                    <p class="total_row_text">Total Row {{rowCount}}</p>

                    <!-- next -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                        (click)="goToNexpage()">keyboard_arrow_right
                    </mat-icon>

                    <!-- last -->
                    <mat-icon style="cursor: pointer; margin-top: -4px;"
                        [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}"
                        (click)="goToLastPage()">last_page
                    </mat-icon>

                </div>

            </div>

        </div>
    </div>
</div>